import { gql } from 'apollo-boost';

export const clubsQuery = gql`
  query {
    clubs {
      id
      shortName
      fullName
    }
  }
`;
